import { render, staticRenderFns } from "./BindEmailDialog.vue?vue&type=template&id=1e67b5dc&scoped=true"
import script from "./BindEmailDialog.vue?vue&type=script&lang=js"
export * from "./BindEmailDialog.vue?vue&type=script&lang=js"
import style0 from "./BindEmailDialog.vue?vue&type=style&index=0&id=1e67b5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e67b5dc",
  null
  
)

export default component.exports